import SectionHeading from "@/pages/home/components/SectionHeading";

const features = [
  {
    id: "f1",
    icon: "ri-list-check-2",
    title: "平台对照",
    desc: "把常用正版平台的中文字幕情况、覆盖地区与适合的内容类型并列展示，一眼看清去哪找。",
  },
  {
    id: "f2",
    icon: "ri-layout-grid-line",
    title: "语种片单",
    desc: "按日语、韩语以及剧集、电影分区整理推荐作品，附类型标签与简要看点，方便按需挑选。",
  },
  {
    id: "f3",
    icon: "ri-file-text-line",
    title: "字幕科普",
    desc: "讲清楚官方字幕、精译、社区协作与软硬字幕的区别，帮你判断一部剧字幕为什么好看或难读。",
  },
  {
    id: "f4",
    icon: "ri-compass-3-line",
    title: "避坑建议",
    desc: "从地区限制到译名差异，把新手最容易困惑的点集中说明，减少无效搜索与试错成本。",
  },
];

export default function IntroSection() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.3fr)] gap-8 lg:gap-14 items-start">
          <SectionHeading
            eyebrow="本站定位"
            title="一份不绕弯子的日韩中文观影指南"
            desc="很多人在搜索「日韩中文字幕哪里看」时，得到的往往是零散、甚至指向不明来源的结果。这一页把真正有用的信息收敛到一起：平台、片单、字幕类型与避坑建议，看到即是完整答案。"
          />
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            {features.map((f) => (
              <div
                key={f.id}
                className="rounded-lg bg-background-100 border border-background-200/70 p-5"
              >
                <span className="w-10 h-10 rounded-md bg-secondary-100 text-secondary-700 flex items-center justify-center">
                  <i className={`${f.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 font-heading text-base md:text-lg font-semibold text-foreground-950">
                  {f.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}